"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExpertTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const workPrinciples = ["Prezzi solo dal listino ufficiale 2026 di SkyDental, voce per voce.", "Nessuna promessa di risultato: le valutazioni cliniche le fa il clinico, sulla panoramica o sulla CBCT.", "Piano scritto entro 24 ore, con trattamento, materiali, sistema implantare e giorni di permanenza.", "Testimonianze solo di pazienti reali che hanno dato il consenso."];
  return <section data-section-id="233384" id="il-team-di-esperti" className="bg-background text-foreground py-24 px-6 md:px-12 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-lg pointer-events-none opacity-30" />

      <div ref={ref} className={`max-w-4xl mx-auto relative z-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-serif font-bold tracking-tight text-foreground">
            Come lavoriamo
          </h2>
        </div>

        <div className="bg-card border border-border rounded-lg p-6 sm:p-8 md:p-10 shadow-sm">
          <ul className="space-y-6">
            {workPrinciples.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4 text-base md:text-lg text-foreground font-default leading-relaxed">
                <div className="mt-1 shrink-0 size-6 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                  <CircleCheck className="size-4" aria-hidden="true" />
                </div>
                <span>{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}